import React, { Component } from 'react';
import { Input, Checkbox } from 'antd';

export class PersonId extends Component {
  render() {
    return (
      <div className="person-id">
        <Input />
        <div className="checkbox-container">
          <Checkbox>CMND</Checkbox>
          <Checkbox>CCCD</Checkbox>
          <Checkbox>Hộ chiếu</Checkbox>
        </div>
      </div>
    )
  }
}
